var _ellipse, _ellipse2, _ellipse3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartTopShineComponents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1118,
    height: 551,
    viewBox: "0 0 1118 551",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "top-shine"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 21493",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3,
    filter: "url(#filter0_f_2131_17459)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 559,
    cy: 125,
    rx: 374,
    ry: 241,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 21494",
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter1_f_2131_17459)"
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 559,
    rx: 222,
    ry: 116,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 21495",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.8,
    filter: "url(#filter2_f_2131_17459)"
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 559,
    cy: -3,
    rx: 375,
    ry: 35,
    fill: "#7551FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2131_17459",
    x: 0,
    y: -301,
    width: 1118,
    height: 852,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 92.5,
    result: "effect1_foregroundBlur_2131_17459"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2131_17459",
    x: 152,
    y: -301,
    width: 814,
    height: 602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 92.5,
    result: "effect1_foregroundBlur_2131_17459"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2131_17459",
    x: 119,
    y: -103,
    width: 880,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32.5,
    result: "effect1_foregroundBlur_2131_17459"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartTopShineComponents);
export default __webpack_public_path__ + "static/media/StartTopShineComponents.58308fdefc5b901ac2afbefbe66f151f.svg";
export { ForwardRef as ReactComponent };